(function () {
  function initMediaSlider(sliderEl) {
    if (sliderEl.dataset.sliderInitialized === 'true') {
      return sliderEl.melalightSlider || null;
    }
    sliderEl.dataset.sliderInitialized = 'true';

    const track = sliderEl.querySelector('[data-slider-track]');
    const slides = Array.from(sliderEl.querySelectorAll('[data-slide]'));
    if (!track || !slides.length) return null;

    const prevBtn = sliderEl.querySelector('[data-slider-prev]');
    const nextBtn = sliderEl.querySelector('[data-slider-next]');
    const dotsContainer = sliderEl.querySelector('[data-slider-dots]');
    const dots = [];
    let currentIndex = 0;
    let peeked = false;

    function goTo(index, instant) {
      currentIndex = (index + slides.length) % slides.length;

      if (instant) {
        const previousTransition = track.style.transition;
        track.style.transition = 'none';
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
        void track.offsetWidth;
        track.style.transition = previousTransition;
      } else {
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
      }

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === currentIndex);
        dot.setAttribute('aria-current', dotIndex === currentIndex ? 'true' : 'false');
      });
    }

    function goToMediaId(mediaId, instant) {
      if (!mediaId) return false;
      const slideIndex = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (slideIndex === -1) return false;
      goTo(slideIndex, instant);
      return true;
    }

    if (slides.length > 1) {
      if (dotsContainer) {
        slides.forEach((slide, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'melalight-two-sizes__slider-dot';
          dot.setAttribute('aria-label', `Go to media ${index + 1} of ${slides.length}`);
          dot.addEventListener('click', () => goTo(index));
          dotsContainer.appendChild(dot);
          dots.push(dot);
        });
      }

      prevBtn?.addEventListener('click', () => goTo(currentIndex - 1));
      nextBtn?.addEventListener('click', () => goTo(currentIndex + 1));

      sliderEl.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(currentIndex - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(currentIndex + 1);
        }
      });

      let touchStartX = null;
      sliderEl.addEventListener(
        'touchstart',
        (event) => {
          touchStartX = event.changedTouches[0].clientX;
        },
        { passive: true }
      );
      sliderEl.addEventListener(
        'touchend',
        (event) => {
          if (touchStartX === null) return;
          const deltaX = event.changedTouches[0].clientX - touchStartX;
          touchStartX = null;
          if (Math.abs(deltaX) < 40) return;
          goTo(deltaX < 0 ? currentIndex + 1 : currentIndex - 1);
        },
        { passive: true }
      );

      const mediaWrapper = sliderEl.closest('.melalight-two-sizes__card-media') || sliderEl;
      mediaWrapper.addEventListener('mouseenter', () => {
        if (peeked || currentIndex !== 0) return;
        peeked = true;
        track.classList.add('is-peeking');
        track.addEventListener(
          'animationend',
          () => track.classList.remove('is-peeking'),
          { once: true }
        );
      });
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplayEnabled = sliderEl.dataset.autoplay === 'true' && !prefersReducedMotion;

      if (autoplayEnabled) {
        const parsedInterval = parseFloat(sliderEl.dataset.autoplayInterval);
        const intervalMs = (Number.isFinite(parsedInterval) && parsedInterval > 0 ? parsedInterval : 4) * 1000;
        let autoplayTimer = null;

        function stopAutoplay() {
          if (autoplayTimer !== null) {
            clearInterval(autoplayTimer);
            autoplayTimer = null;
          }
        }

        function startAutoplay() {
          stopAutoplay();
          autoplayTimer = setInterval(() => goTo(currentIndex + 1), intervalMs);
        }

        mediaWrapper.addEventListener('mouseenter', stopAutoplay);
        mediaWrapper.addEventListener('mouseleave', startAutoplay);
        sliderEl.addEventListener('focusin', stopAutoplay);
        sliderEl.addEventListener('focusout', startAutoplay);
        sliderEl.addEventListener('touchstart', stopAutoplay, { passive: true });

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            stopAutoplay();
          } else {
            startAutoplay();
          }
        });

        startAutoplay();
      }
    }

    goTo(0, true);

    const api = { goTo, goToMediaId };
    sliderEl.melalightSlider = api;
    return api;
  }

  function initSingleCard(section) {
    const card = section.querySelector('[data-single-card]');
    if (!card) return;

    const form = card.querySelector('form');
    const variantInput = form?.querySelector('.product-variant-id');
    const titleEl = card.querySelector('[data-product-title]');
    const imageEl = card.querySelector('.melalight-two-sizes__card-image');
    const slider = card.querySelector('[data-media-slider]')?.melalightSlider;
    const submitBtn = card.querySelector('[data-submit-button]');
    const submitLabel = submitBtn?.querySelector('[data-submit-label]');
    const sizeSpecLabel = card.querySelector('[data-size-spec-label]');
    const sizeSpecValue = card.querySelector('[data-size-spec-value]');
    const salePromotions = card.querySelectorAll('[data-sale-promotion]');
    const saveBadge = card.querySelector('[data-single-save-badge]');
    const options = card.querySelectorAll('[data-variant-option]');

    if (!form || !variantInput || !options.length) return;

    function selectVariant(button) {
      const variantId = button.dataset.variantId;
      const variantTitle = button.dataset.variantTitle || '';
      const price = button.dataset.price;
      const formattedPrice = button.dataset.formattedPrice || '';
      const formattedSavings = button.dataset.formattedSavings || '';
      const comparePrice = Number(button.dataset.comparePrice || 0);
      const numericPrice = Number(price || 0);
      const imageSrc = button.dataset.image;
      const mediaId = button.dataset.mediaId;

      options.forEach((option) => {
        option.classList.toggle('is-active', option === button);
        option.setAttribute('aria-pressed', option === button ? 'true' : 'false');
      });

      card.querySelectorAll('[data-bundle-offer-variant]').forEach((panel) => {
        panel.hidden = panel.dataset.bundleOfferVariant !== variantId;
      });
      variantInput.value = variantId;
      variantInput.disabled = button.dataset.available !== 'true';

      if (titleEl && variantTitle) {
        titleEl.textContent = `MELALIGHT ${variantTitle.toUpperCase().replace(/LAMP/g, '').trim()} RED LIGHT LAMP`;
      }

      if (sizeSpecValue && variantTitle) {
        const isTall = variantTitle.toLowerCase().includes('tall');
        const specKey = isTall ? 'tallSpec' : 'shortSpec';
        sizeSpecValue.textContent = sizeSpecValue.dataset[specKey] || '';
        if (sizeSpecLabel) sizeSpecLabel.textContent = isTall ? 'Tall Lamp:' : 'Short Lamp:';
      }

      const slidChanged = slider ? slider.goToMediaId(mediaId) : false;
      if (!slidChanged && !slider && imageEl && imageSrc) {
        imageEl.src = imageSrc;
        imageEl.srcset = '';
      }

      if (submitLabel && formattedPrice) {
        submitLabel.textContent = card.dataset.bundleOfferActive === 'true' ? 'ADD TO CART' : `ADD TO CART - ${formattedPrice}`;
      }

      const isOnSale = comparePrice > numericPrice;
      salePromotions.forEach((promotion) => {
        promotion.hidden = !isOnSale;
      });
      if (saveBadge) {
        saveBadge.textContent = isOnSale && formattedSavings ? `Save ${formattedSavings}` : '';
      }

      if (submitBtn) {
        submitBtn.disabled = button.dataset.available !== 'true';
      }
    }

    options.forEach((option) => {
      option.addEventListener('click', () => selectVariant(option));
    });

    const activeOption = card.querySelector('[data-variant-option].is-active');
    if (slider && activeOption?.dataset.mediaId) {
      slider.goToMediaId(activeOption.dataset.mediaId, true);
    }
  }

  function initBundleCard(section) {
    const card = section.querySelector('[data-bundle-card]');
    if (!card) return;

    const form = card.querySelector('form');
    const variantInput = form?.querySelector('.product-variant-id');
    const slider = card.querySelector('[data-media-slider]')?.melalightSlider;
    const imageEl = card.querySelector('.melalight-two-sizes__card-image');
    const descriptionEl = card.querySelector('[data-bundle-lamps-description]');
    const saveBadge = card.querySelector('[data-bundle-save-badge]');
    const salePromotions = card.querySelectorAll('[data-sale-promotion]');
    const submitBtn = card.querySelector('[data-bundle-submit-button]');
    const priceEl = card.querySelector('[data-bundle-price]');
    const comparePriceEl = card.querySelector('[data-bundle-compare-price]');
    const dimensions = card.querySelectorAll('[data-bundle-dimension]');
    const options = card.querySelectorAll('[data-bundle-variant-option]');

    if (!form || !variantInput || !options.length) return;

    function selectVariant(button, updateImage = true) {
      const variantTitle = button.dataset.variantTitle || '';
      const normalizedTitle = variantTitle.toLowerCase();
      const price = Number(button.dataset.price || 0);
      const comparePrice = Number(button.dataset.comparePrice || 0);
      const formattedPrice = button.dataset.formattedPrice || '';
      const formattedComparePrice = button.dataset.formattedComparePrice || '';
      const formattedSavings = button.dataset.formattedSavings || '';
      const isAvailable = button.dataset.available === 'true';

      options.forEach((option) => {
        option.classList.toggle('is-active', option === button);
        option.setAttribute('aria-pressed', option === button ? 'true' : 'false');
      });

      card.querySelectorAll('[data-bundle-offer-variant]').forEach((panel) => {
        panel.hidden = panel.dataset.bundleOfferVariant !== button.dataset.variantId;
      });
      variantInput.value = button.dataset.variantId;
      variantInput.disabled = !isAvailable;

      if (descriptionEl) {
        descriptionEl.textContent = `2 MELALIGHT Red Light Lamps (${variantTitle})`;
      }

      dimensions.forEach((dimension) => {
        dimension.hidden = !normalizedTitle.includes(dimension.dataset.bundleDimension);
      });

      const slideChanged = updateImage && slider ? slider.goToMediaId(button.dataset.mediaId) : false;
      if (updateImage && !slideChanged && !slider && imageEl && button.dataset.image) {
        imageEl.src = button.dataset.image;
        imageEl.srcset = '';
      }

      if (priceEl && formattedPrice) priceEl.textContent = card.dataset.bundleOfferActive === 'true' ? 'ADD TO CART' : `ADD TO CART - ${formattedPrice}`;
      if (comparePriceEl) {
        comparePriceEl.hidden = comparePrice <= price;
        comparePriceEl.textContent = comparePrice > price ? formattedComparePrice : '';
      }
      const isOnSale = comparePrice > price;
      salePromotions.forEach((promotion) => {
        promotion.hidden = !isOnSale;
      });
      if (saveBadge) saveBadge.textContent = isOnSale && formattedSavings ? `Save ${formattedSavings}` : '';
      if (submitBtn) submitBtn.disabled = !isAvailable;
    }

    options.forEach((option) => {
      option.addEventListener('click', () => selectVariant(option));
    });

    const activeOption = card.querySelector('[data-bundle-variant-option].is-active');
    if (activeOption) selectVariant(activeOption, !card.hasAttribute('data-preserve-initial-image'));
  }

  function initSections() {
    document.querySelectorAll('[data-melalight-two-sizes]').forEach((section) => {
      section.querySelectorAll('[data-media-slider]').forEach((slider) => {
        initMediaSlider(slider);
      });
      initSingleCard(section);
      initBundleCard(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSections);
  } else {
    initSections();
  }

  document.addEventListener('shopify:section:load', initSections);
})();
